__webpack_require__.p = "https://dynamic-template.api-domain-compado.com/production/f13f34564179a9b020e97c412439f7902cfa90bf/ghost-writer/";